import { Link } from 'react-router-dom';
import { Button, Card } from '@tokenforge/design-system';

export default function RegistrationUnavailable() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="max-w-md space-y-4 text-center">
        <p className="text-xs uppercase tracking-[0.18em] text-foreground/50">TokenForge SaaS</p>
        <h1 className="text-xl font-semibold">当前工作空间不开放自助开通</h1>
        <p className="text-sm leading-6 text-foreground/60">
          请使用企业邀请邮件完成加入，或联系工作空间管理员为你创建访问权限。
        </p>
        <Link to="/login">
          <Button className="w-full">前往登录</Button>
        </Link>
      </Card>
    </main>
  );
}
